<template>
    <footer class="site-footer" :class="topOuterDivider && 'has-top-divider'">
        <div class="container">
            <div class="site-footer-inner" :class="topDivider && 'has-top-divider'">
                <div class="footer-top text-xxs">
                    <div class="footer-blocks">
                        <div class="footer-block reveal-from-bottom" data-reveal-offset="0">
                            <c-logo class="mb-16" />
                            <div class="footer-copyright">&copy; 2020 SmartAlgo, all rights reserved</div>
                        </div>
                        <div class="footer-block reveal-from-bottom" data-reveal-offset="0" data-reveal-delay="100">
                            <div class="footer-block-title">Resources</div>
                            <ul class="list-reset">
                                <li>
                                    <a href="https://www.tradingview.com/u/SmartAlgos/#published-scripts" target="_blank">Premium Indicators</a>
                                </li>
                                <li>
                                    <anchor-router-link :to="{hash: '#faq', name: 'home'}">Frequently Asked Questions</anchor-router-link>
                                </li>
                                <li>
                                    <a href="https://discord.gg/CE7fHRZmaR" target="_blank">Discord Server</a>
                                </li>

                            </ul>
                        </div>
                        <div class="footer-block reveal-from-bottom" data-reveal-offset="0" data-reveal-delay="200">
                            <div class="footer-block-title">Account</div>
                            <ul class="list-reset">
                                <li>
                                    <anchor-router-link :to="{hash: '#pricing', name: 'home'}">Sign Up</anchor-router-link>
                                </li>
                                <li>
                                    <anchor-router-link :to="{hash: '#pricing', name: 'home'}">Pricing</anchor-router-link>
                                </li>
                                <li>
                                    <a href="javascript:void(0)" data-cb-type="portal">Manage Account</a>
                                </li>
                                <li>
                                    <a href="https://smartalgo.refersion.com/affiliate/registration" target="_blank">Affiliate Program</a>
                                </li>
                            </ul>
                        </div>

                        <div class="footer-block reveal-from-bottom" data-reveal-offset="0" data-reveal-delay="200">
                            <div class="footer-block-title">Legal</div>
                                <ul class="list-reset">
                                    <li>
                                        <router-link to="/terms/">Terms Of Service</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/privacy/">Privacy Policy</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/refunds/">Refund Policy</router-link>
                                    </li>
                                    <li>
                                        <router-link to="/disclaimer/">Disclaimer</router-link>
                                    </li>
                                </ul>
                        </div>
                    </div>
                </div>
                <div class="footer-bottom space-between center-content-mobile text-xxs reveal-from-bottom" data-reveal-offset="0">
                    <c-footer-nav />
                    <c-footer-social />
                </div>
            </div>
        </div>
        <cookie-law theme="base" buttonClass="button button-primary button-wide-mobile"></cookie-law>
    </footer>
</template>

<script>
import CLogo from '@/components/layout/partials/Logo.vue'
import AnchorRouterLink from 'vue-anchor-router-link'
import CookieLaw from 'vue-cookie-law'
import CFooterNav from '@/components/layout/partials/FooterNav.vue'
import CFooterSocial from '@/components/layout/partials/FooterSocial.vue'

export default {
  name: 'CFooter',
  components: {
    CLogo,
    CookieLaw,
    AnchorRouterLink,
    CFooterNav,
    CFooterSocial
  },
  props: {
    topOuterDivider: {
      type: Boolean,
      default: false
    },      
    topDivider: {
      type: Boolean,
      default: false
    }
  }
}
</script>